const countries = [
  {
    country_id: 100,
    label: "United States of America",
    country_isd_code: "1",
    value: "US",
  },
  {
    country_id: 200,
    label: "Afghanistan",
    country_isd_code: "93",
    value: "AF",
  },
  {
    country_id: 201,
    label: "Aland Islands",
    country_isd_code: "358",
    value: "AX",
  },
  { country_id: 202, label: "Albania", country_isd_code: "355", value: "AL" },
  { country_id: 203, label: "Algeria", country_isd_code: "213", value: "DZ" },
  {
    country_id: 204,
    label: "American Samoa",
    country_isd_code: "1-684",
    value: "AS",
  },
  { country_id: 205, label: "Andorra", country_isd_code: "376", value: "AD" },
  { country_id: 206, label: "Angola", country_isd_code: "244", value: "AO" },
  {
    country_id: 207,
    label: "Anguilla",
    country_isd_code: "1-264",
    value: "AI",
  },
  {
    country_id: 208,
    label: "Antarctica",
    country_isd_code: "672",
    value: "AQ",
  },
  {
    country_id: 209,
    label: "Antigua and Barbuda",
    country_isd_code: "1-268",
    value: "AG",
  },
  { country_id: 210, label: "Argentina", country_isd_code: "54", value: "AR" },
  { country_id: 211, label: "Armenia", country_isd_code: "374", value: "AM" },
  { country_id: 212, label: "Aruba", country_isd_code: "297", value: "AW" },
  {
    country_id: 213,
    label: "Ascension Island",
    country_isd_code: "247",
    value: "AC",
  },
  { country_id: 214, label: "Australia", country_isd_code: "61", value: "AU" },
  { country_id: 215, label: "Austria", country_isd_code: "43", value: "AT" },
  {
    country_id: 216,
    label: "Azerbaijan",
    country_isd_code: "994",
    value: "AZ",
  },
  { country_id: 217, label: "Bahamas", country_isd_code: "1-242", value: "BS" },
  { country_id: 218, label: "Bahrain", country_isd_code: "973", value: "BH" },
  {
    country_id: 219,
    label: "Bangladesh",
    country_isd_code: "880",
    value: "BD",
  },
  {
    country_id: 220,
    label: "Barbados",
    country_isd_code: "1-246",
    value: "BB",
  },
//   { country_id: 221, label: "Belarus", country_isd_code: "375", value: "BY" },
  { country_id: 222, label: "Belgium", country_isd_code: "32", value: "BE" },
  { country_id: 223, label: "Belize", country_isd_code: "501", value: "BZ" },
  { country_id: 224, label: "Benin", country_isd_code: "229", value: "BJ" },
  { country_id: 225, label: "Bermuda", country_isd_code: "1-441", value: "BM" },
  { country_id: 226, label: "Bhutan", country_isd_code: "975", value: "BT" },
  { country_id: 227, label: "Bolivia", country_isd_code: "591", value: "BO" },
  {
    country_id: 228,
    label: "Bonaire, Sint Eustatius and Saba",
    country_isd_code: "599",
    value: "BQ",
  },
  {
    country_id: 229,
    label: "Bosnia and Herzegovina",
    country_isd_code: "387",
    value: "BA",
  },
  { country_id: 230, label: "Botswana", country_isd_code: "267", value: "BW" },
  {
    country_id: 231,
    label: "Bouvet Island",
    country_isd_code: "47",
    value: "BV",
  },
  { country_id: 232, label: "Brazil", country_isd_code: "55", value: "BR" },
  {
    country_id: 233,
    label: "British Indian Ocean Territory",
    country_isd_code: "246",
    value: "IO",
  },
  {
    country_id: 234,
    label: "Brunei Darussalam",
    country_isd_code: "673",
    value: "BN",
  },
  { country_id: 235, label: "Bulgaria", country_isd_code: "359", value: "BG" },
  {
    country_id: 236,
    label: "Burkina Faso",
    country_isd_code: "226",
    value: "BF",
  },
  { country_id: 237, label: "Burundi", country_isd_code: "257", value: "BI" },
  { country_id: 238, label: "Cambodia", country_isd_code: "855", value: "KH" },
  { country_id: 239, label: "Cameroon", country_isd_code: "237", value: "CM" },
  { country_id: 240, label: "Canada", country_isd_code: "1", value: "CA" },
  {
    country_id: 241,
    label: "Canary Islands",
    country_isd_code: "34",
    value: "IC",
  },
  {
    country_id: 242,
    label: "Cape Verde",
    country_isd_code: "238",
    value: "CV",
  },
  {
    country_id: 243,
    label: "Cayman Islands",
    country_isd_code: "1-345",
    value: "KY",
  },
  {
    country_id: 244,
    label: "Central African Republic",
    country_isd_code: "236",
    value: "CF",
  },
  {
    country_id: 245,
    label: "Ceuta, Melilla",
    country_isd_code: "34",
    value: "EA",
  },
  { country_id: 246, label: "Chad", country_isd_code: "235", value: "TD" },
  { country_id: 247, label: "Chile", country_isd_code: "56", value: "CL" },
  { country_id: 248, label: "China", country_isd_code: "86", value: "CN" },
  {
    country_id: 249,
    label: "Christmas Island",
    country_isd_code: "61",
    value: "CX",
  },
  {
    country_id: 250,
    label: "Clipperton Island",
    country_isd_code: "1",
    value: "CP",
  },
  {
    country_id: 251,
    label: "Cocos (Keeling) Islands",
    country_isd_code: "61",
    value: "CC",
  },
  { country_id: 252, label: "Colombia", country_isd_code: "57", value: "CO" },
  { country_id: 253, label: "Comoros", country_isd_code: "269", value: "KM" },
  { country_id: 254, label: "Congo", country_isd_code: "242", value: "CG" },
  {
    country_id: 255,
    label: "Congo, the Democratic Republic of the",
    country_isd_code: "243",
    value: "CD",
  },
  {
    country_id: 256,
    label: "Cook Islands",
    country_isd_code: "682",
    value: "CK",
  },
  {
    country_id: 257,
    label: "Costa Rica",
    country_isd_code: "506",
    value: "CR",
  },
  { country_id: 259, label: "Croatia", country_isd_code: "385", value: "HR" },
  { country_id: 260, label: "Cuba", country_isd_code: "53", value: "CU" },
  { country_id: 261, label: "Curaçao", country_isd_code: "599", value: "CW" },
  { country_id: 262, label: "Cyprus", country_isd_code: "357", value: "CY" },
  {
    country_id: 263,
    label: "Czech Republic",
    country_isd_code: "420",
    value: "CZ",
  },
  {
    country_id: 258,
    label: "Côte d'ivoire",
    country_isd_code: "225",
    value: "CI",
  },
  { country_id: 264, label: "Denmark", country_isd_code: "45", value: "DK" },
  {
    country_id: 265,
    label: "Diego Garcia",
    country_isd_code: "246",
    value: "DG",
  },
  { country_id: 266, label: "Djibouti", country_isd_code: "253", value: "DJ" },
  {
    country_id: 267,
    label: "Dominica",
    country_isd_code: "1-767",
    value: "DM",
  },
  {
    country_id: 268,
    label: "Dominican Republic",
    country_isd_code: "1",
    value: "DO",
  },
  { country_id: 269, label: "Ecuador", country_isd_code: "593", value: "EC" },
  { country_id: 270, label: "Egypt", country_isd_code: "20", value: "EG" },
  {
    country_id: 271,
    label: "El Salvador",
    country_isd_code: "503",
    value: "SV",
  },
  {
    country_id: 272,
    label: "Equatorial Guinea",
    country_isd_code: "240",
    value: "GQ",
  },
  { country_id: 273, label: "Eritrea", country_isd_code: "291", value: "ER" },
  { country_id: 274, label: "Estonia", country_isd_code: "372", value: "EE" },
  { country_id: 275, label: "Ethiopia", country_isd_code: "251", value: "ET" },
  {
    country_id: 276,
    label: "European Union",
    country_isd_code: "33",
    value: "EU",
  },
  {
    country_id: 277,
    label: "Falkland Islands (Malvinas)",
    country_isd_code: "500",
    value: "FK",
  },
  {
    country_id: 278,
    label: "Faroe Islands",
    country_isd_code: "298",
    value: "FO",
  },
  { country_id: 279, label: "Fiji", country_isd_code: "679", value: "FJ" },
  { country_id: 280, label: "Finland", country_isd_code: "358", value: "FI" },
  { country_id: 281, label: "France", country_isd_code: "33", value: "FR" },
  // {
  //   country_id: 282,
  //   label: "France, Metropolitan",
  //   country_isd_code: "33",
  //   value: "FX",
  // },
  {
    country_id: 283,
    label: "French Guiana",
    country_isd_code: "33",
    value: "GF",
  },
  {
    country_id: 284,
    label: "French Polynesia",
    country_isd_code: "689",
    value: "PF",
  },
  {
    country_id: 285,
    label: "French Southern Territories",
    country_isd_code: "33",
    value: "TF",
  },
  { country_id: 286, label: "Gabon", country_isd_code: "241", value: "GA" },
  { country_id: 287, label: "Gambia", country_isd_code: "220", value: "GM" },
  { country_id: 288, label: "Georgia", country_isd_code: "995", value: "GE" },
  { country_id: 289, label: "Germany", country_isd_code: "49", value: "DE" },
  { country_id: 290, label: "Ghana", country_isd_code: "233", value: "GH" },
  { country_id: 291, label: "Gibraltar", country_isd_code: "350", value: "GI" },
  { country_id: 292, label: "Greece", country_isd_code: "30", value: "GR" },
  { country_id: 293, label: "Greenland", country_isd_code: "299", value: "GL" },
  { country_id: 294, label: "Grenada", country_isd_code: "1-473", value: "GD" },
  {
    country_id: 295,
    label: "Guadeloupe",
    country_isd_code: "590",
    value: "GP",
  },
  { country_id: 296, label: "Guam", country_isd_code: "1-671", value: "GU" },
  { country_id: 297, label: "Guatemala", country_isd_code: "502", value: "GT" },
  {
    country_id: 298,
    label: "Guernsey",
    country_isd_code: "44-1481",
    value: "GG",
  },
  { country_id: 299, label: "Guinea", country_isd_code: "224", value: "GN" },
  {
    country_id: 300,
    label: "Guinea-Bissau",
    country_isd_code: "245",
    value: "GW",
  },
  { country_id: 301, label: "Guyana", country_isd_code: "592", value: "GY" },
  { country_id: 302, label: "Haiti", country_isd_code: "509", value: "HT" },
  {
    country_id: 303,
    label: "Heard Island and McDonald Islands",
    country_isd_code: "61",
    value: "HM",
  },
  {
    country_id: 304,
    label: "Holy See (Vatican City State)",
    country_isd_code: "379",
    value: "VA",
  },
  { country_id: 305, label: "Honduras", country_isd_code: "504", value: "HN" },
  { country_id: 306, label: "Hong Kong", country_isd_code: "852", value: "HK" },
  { country_id: 307, label: "Hungary", country_isd_code: "36", value: "HU" },
  { country_id: 308, label: "Iceland", country_isd_code: "354", value: "IS" },
  { country_id: 309, label: "India", country_isd_code: "91", value: "IN" },
  { country_id: 310, label: "Indonesia", country_isd_code: "62", value: "ID" },
  {
    country_id: 311,
    label: "Iran, Islamic Republic of",
    country_isd_code: "98",
    value: "IR",
  },
  { country_id: 312, label: "Iraq", country_isd_code: "964", value: "IQ" },
  { country_id: 313, label: "Ireland", country_isd_code: "353", value: "IE" },
  {
    country_id: 314,
    label: "Isle of Man",
    country_isd_code: "44-1624",
    value: "IM",
  },
  { country_id: 315, label: "Israel", country_isd_code: "972", value: "IL" },
  { country_id: 316, label: "Italy", country_isd_code: "39", value: "IT" },
  { country_id: 317, label: "Jamaica", country_isd_code: "1-876", value: "JM" },
  { country_id: 318, label: "Japan", country_isd_code: "81", value: "JP" },
  {
    country_id: 319,
    label: "Jersey",
    country_isd_code: "44-1534",
    value: "JE",
  },
  { country_id: 320, label: "Jordan", country_isd_code: "962", value: "JO" },
  { country_id: 321, label: "Kazakhstan", country_isd_code: "7", value: "KZ" },
  { country_id: 322, label: "Kenya", country_isd_code: "254", value: "KE" },
  { country_id: 323, label: "Kiribati", country_isd_code: "686", value: "KI" },
  {
    country_id: 325,
    label: "Korea, Republic of",
    country_isd_code: "82",
    value: "KR",
  },
  { country_id: 326, label: "Kuwait", country_isd_code: "965", value: "KW" },
  {
    country_id: 327,
    label: "Kyrgyzstan",
    country_isd_code: "996",
    value: "KG",
  },
  {
    country_id: 328,
    label: "Lao People's Democratic Republic",
    country_isd_code: "856",
    value: "LA",
  },
  { country_id: 329, label: "Latvia", country_isd_code: "371", value: "LV" },
  { country_id: 330, label: "Lebanon", country_isd_code: "961", value: "LB" },
  { country_id: 331, label: "Lesotho", country_isd_code: "266", value: "LS" },
  { country_id: 332, label: "Liberia", country_isd_code: "231", value: "LR" },
  { country_id: 333, label: "Libya", country_isd_code: "218", value: "LY" },
  {
    country_id: 334,
    label: "Liechtenstein",
    country_isd_code: "423",
    value: "LI",
  },
  { country_id: 335, label: "Lithuania", country_isd_code: "370", value: "LT" },
  {
    country_id: 336,
    label: "Luxembourg",
    country_isd_code: "352",
    value: "LU",
  },
  { country_id: 337, label: "Macao", country_isd_code: "853", value: "MO" },
  {
    country_id: 338,
    label: "Macedonia, the former Yugoslav Republic of",
    country_isd_code: "389",
    value: "MK",
  },
  {
    country_id: 339,
    label: "Madagascar",
    country_isd_code: "261",
    value: "MG",
  },
  { country_id: 340, label: "Malawi", country_isd_code: "265", value: "MW" },
  { country_id: 341, label: "Malaysia", country_isd_code: "60", value: "MY" },
  { country_id: 342, label: "Maldives", country_isd_code: "960", value: "MV" },
  { country_id: 343, label: "Mali", country_isd_code: "223", value: "ML" },
  { country_id: 344, label: "Malta", country_isd_code: "356", value: "MT" },
  {
    country_id: 345,
    label: "Marshall Islands",
    country_isd_code: "692",
    value: "MH",
  },
  {
    country_id: 346,
    label: "Martinique",
    country_isd_code: "596",
    value: "MQ",
  },
  {
    country_id: 347,
    label: "Mauritania",
    country_isd_code: "222",
    value: "MR",
  },
  { country_id: 348, label: "Mauritius", country_isd_code: "230", value: "MU" },
  { country_id: 349, label: "Mayotte", country_isd_code: "262", value: "YT" },
  { country_id: 350, label: "Mexico", country_isd_code: "52", value: "MX" },
  {
    country_id: 351,
    label: "Micronesia, Federated States of",
    country_isd_code: "691",
    value: "FM",
  },
  {
    country_id: 352,
    label: "Moldova, Republic of",
    country_isd_code: "373",
    value: "MD",
  },
  { country_id: 353, label: "Monaco", country_isd_code: "377", value: "MC" },
  { country_id: 354, label: "Mongolia", country_isd_code: "976", value: "MN" },
  {
    country_id: 355,
    label: "Montenegro",
    country_isd_code: "382",
    value: "ME",
  },
  {
    country_id: 356,
    label: "Montserrat",
    country_isd_code: "1-664",
    value: "MS",
  },
  { country_id: 357, label: "Morocco", country_isd_code: "212", value: "MA" },
  {
    country_id: 358,
    label: "Mozambique",
    country_isd_code: "258",
    value: "MZ",
  },
  { country_id: 359, label: "Myanmar", country_isd_code: "95", value: "MM" },
  { country_id: 360, label: "Namibia", country_isd_code: "264", value: "NA" },
  { country_id: 361, label: "Nauru", country_isd_code: "674", value: "NR" },
  { country_id: 362, label: "Nepal", country_isd_code: "977", value: "NP" },
  {
    country_id: 363,
    label: "Netherlands",
    country_isd_code: "31",
    value: "NL",
  },
  {
    country_id: 364,
    label: "New Caledonia",
    country_isd_code: "687",
    value: "NC",
  },
  {
    country_id: 365,
    label: "New Zealand",
    country_isd_code: "64",
    value: "NZ",
  },
  { country_id: 366, label: "Nicaragua", country_isd_code: "505", value: "NI" },
  { country_id: 367, label: "Niger", country_isd_code: "227", value: "NE" },
  { country_id: 368, label: "Nigeria", country_isd_code: "234", value: "NG" },
  { country_id: 369, label: "Niue", country_isd_code: "683", value: "NU" },
  {
    country_id: 370,
    label: "Norfolk Island",
    country_isd_code: "672",
    value: "NF",
  },
  {
    country_id: 371,
    label: "Northern Mariana Islands",
    country_isd_code: "1-670",
    value: "MP",
  },
  { country_id: 372, label: "Norway", country_isd_code: "47", value: "NO" },
  { country_id: 373, label: "Oman", country_isd_code: "968", value: "OM" },
  { country_id: 374, label: "Pakistan", country_isd_code: "92", value: "PK" },
  { country_id: 375, label: "Palau", country_isd_code: "680", value: "PW" },
  {
    country_id: 376,
    label: "Palestinian Territory, Occupied",
    country_isd_code: "970",
    value: "PS",
  },
  { country_id: 377, label: "Panama", country_isd_code: "507", value: "PA" },
  {
    country_id: 378,
    label: "Papua New Guinea",
    country_isd_code: "675",
    value: "PG",
  },
  { country_id: 379, label: "Paraguay", country_isd_code: "595", value: "PY" },
  { country_id: 380, label: "Peru", country_isd_code: "51", value: "PE" },
  {
    country_id: 381,
    label: "Philippines",
    country_isd_code: "63",
    value: "PH",
  },
  { country_id: 382, label: "Pitcairn", country_isd_code: "64", value: "PN" },
  { country_id: 383, label: "Poland", country_isd_code: "48", value: "PL" },
  { country_id: 384, label: "Portugal", country_isd_code: "351", value: "PT" },
  {
    country_id: 385,
    label: "Puerto Rico",
    country_isd_code: "1787",
    value: "PR",
  },
  { country_id: 386, label: "Qatar", country_isd_code: "974", value: "QA" },
  { country_id: 387, label: "Reunion", country_isd_code: "262", value: "RE" },
  { country_id: 388, label: "Romania", country_isd_code: "40", value: "RO" },
//   {
//     country_id: 389,
//     label: "Russian Federation (Russia)",
//     country_isd_code: "7",
//     value: "RU",
//   },
  { country_id: 390, label: "Rwanda", country_isd_code: "250", value: "RW" },
  {
    country_id: 391,
    label: "Saint Barthelemy",
    country_isd_code: "590",
    value: "BL",
  },
  {
    country_id: 392,
    label: "Saint Helena, Ascension and Tristan da Cunha",
    country_isd_code: "290",
    value: "SH",
  },
  {
    country_id: 393,
    label: "Saint Kitts and Nevis",
    country_isd_code: "1-869",
    value: "KN",
  },
  {
    country_id: 394,
    label: "Saint Lucia",
    country_isd_code: "1-758",
    value: "LC",
  },
  {
    country_id: 395,
    label: "Saint Martin (French part)",
    country_isd_code: "590",
    value: "MF",
  },
  {
    country_id: 396,
    label: "Saint Pierre and Miquelon",
    country_isd_code: "508",
    value: "PM",
  },
  {
    country_id: 397,
    label: "Saint Vincent and the Grenadines",
    country_isd_code: "1-784",
    value: "VC",
  },
  { country_id: 398, label: "Samoa", country_isd_code: "685", value: "WS" },
  {
    country_id: 399,
    label: "San Marino",
    country_isd_code: "378",
    value: "SM",
  },
  {
    country_id: 400,
    label: "Sao Tome and Principe",
    country_isd_code: "239",
    value: "ST",
  },
  {
    country_id: 401,
    label: "Saudi Arabia",
    country_isd_code: "966",
    value: "SA",
  },
  { country_id: 402, label: "Senegal", country_isd_code: "221", value: "SN" },
  { country_id: 403, label: "Serbia", country_isd_code: "381", value: "RS" },
  {
    country_id: 404,
    label: "Seychelles",
    country_isd_code: "248",
    value: "SC",
  },
  {
    country_id: 405,
    label: "Sierra Leone",
    country_isd_code: "232",
    value: "SL",
  },
  { country_id: 406, label: "Singapore", country_isd_code: "65", value: "SG" },
  {
    country_id: 407,
    label: "Sint Maarten (Dutch part)",
    country_isd_code: "1-721",
    value: "SX",
  },
  { country_id: 408, label: "Slovakia", country_isd_code: "421", value: "SK" },
  { country_id: 409, label: "Slovenia", country_isd_code: "386", value: "SI" },
  {
    country_id: 410,
    label: "Solomon Islands",
    country_isd_code: "677",
    value: "SB",
  },
  { country_id: 411, label: "Somalia", country_isd_code: "252", value: "SO" },
  {
    country_id: 412,
    label: "South Africa",
    country_isd_code: "27",
    value: "ZA",
  },
  {
    country_id: 413,
    label: "South Georgia and the South Sandwich Islands",
    country_isd_code: "500",
    value: "GS",
  },
  {
    country_id: 414,
    label: "South Sudan",
    country_isd_code: "211",
    value: "SS",
  },
  { country_id: 415, label: "Spain", country_isd_code: "34", value: "ES" },
  { country_id: 416, label: "Sri Lanka", country_isd_code: "94", value: "LK" },
  { country_id: 417, label: "Sudan", country_isd_code: "249", value: "SD" },
  { country_id: 418, label: "Suriname", country_isd_code: "597", value: "SR" },
  {
    country_id: 419,
    label: "Svalbard and Jan Mayen",
    country_isd_code: "47",
    value: "SJ",
  },
  { country_id: 420, label: "Swaziland", country_isd_code: "268", value: "SZ" },
  { country_id: 421, label: "Sweden", country_isd_code: "46", value: "SE" },
  {
    country_id: 422,
    label: "Switzerland",
    country_isd_code: "41",
    value: "CH",
  },
  {
    country_id: 423,
    label: "Syrian Arab Republic",
    country_isd_code: "963",
    value: "SY",
  },
  {
    country_id: 424,
    label: "Taiwan, Province of China",
    country_isd_code: "886",
    value: "TW",
  },
  {
    country_id: 425,
    label: "Tajikistan",
    country_isd_code: "992",
    value: "TJ",
  },
  {
    country_id: 426,
    label: "Tanzania, United Republic of",
    country_isd_code: "255",
    value: "TZ",
  },
  { country_id: 427, label: "Thailand", country_isd_code: "66", value: "TH" },
  {
    country_id: 428,
    label: "Timor-Leste",
    country_isd_code: "670",
    value: "TL",
  },
  { country_id: 429, label: "Togo", country_isd_code: "228", value: "TG" },
  { country_id: 430, label: "Tokelau", country_isd_code: "690", value: "TK" },
  { country_id: 431, label: "Tonga", country_isd_code: "676", value: "TO" },
  {
    country_id: 432,
    label: "Trinidad and Tobago",
    country_isd_code: "1-868",
    value: "TT",
  },
  {
    country_id: 433,
    label: "Tristan da Cunha",
    country_isd_code: "290",
    value: "TA",
  },
  { country_id: 434, label: "Tunisia", country_isd_code: "216", value: "TN" },
  { country_id: 435, label: "Turkey", country_isd_code: "90", value: "TR" },
  {
    country_id: 436,
    label: "Turkmenistan",
    country_isd_code: "993",
    value: "TM",
  },
  {
    country_id: 437,
    label: "Turks and Caicos Islands",
    country_isd_code: "1-649",
    value: "TC",
  },
  { country_id: 438, label: "Tuvalu", country_isd_code: "688", value: "TV" },
  { country_id: 439, label: "Uganda", country_isd_code: "256", value: "UG" },
  { country_id: 440, label: "Ukraine", country_isd_code: "380", value: "UA" },
  {
    country_id: 441,
    label: "United Arab Emirates",
    country_isd_code: "971",
    value: "AE",
  },
  {
    country_id: 442,
    label: "United Kingdom (GB)",
    country_isd_code: "44",
    value: "GB",
  },
  {
    country_id: 444,
    label: "United States Minor Outlying Islands",
    country_isd_code: "1",
    value: "UM",
  },
  { country_id: 445, label: "Uruguay", country_isd_code: "598", value: "UY" },
  {
    country_id: 447,
    label: "Uzbekistan",
    country_isd_code: "998",
    value: "UZ",
  },
  { country_id: 448, label: "Vanuatu", country_isd_code: "678", value: "VU" },
  {
    country_id: 449,
    label: "Venezuela, Bolivarian Republic of",
    country_isd_code: "58",
    value: "VE",
  },
  { country_id: 450, label: "Viet Nam", country_isd_code: "84", value: "VN" },
  {
    country_id: 451,
    label: "Virgin Islands, British",
    country_isd_code: "1-284",
    value: "VG",
  },
  {
    country_id: 452,
    label: "Virgin Islands, U.S.",
    country_isd_code: "1-340",
    value: "VI",
  },
  {
    country_id: 453,
    label: "Wallis and Futuna",
    country_isd_code: "681",
    value: "WF",
  },
  {
    country_id: 454,
    label: "Western Sahara",
    country_isd_code: "212",
    value: "EH",
  },
  { country_id: 455, label: "Yemen", country_isd_code: "967", value: "YE" },
  { country_id: 456, label: "Zambia", country_isd_code: "260", value: "ZM" },
  { country_id: 457, label: "Zimbabwe", country_isd_code: "263", value: "ZW" },
];
export default countries;
